import { FULFILLMENT } from '../../constants';
import { createSelector } from 'reselect';

const REQUEST_STATUS = FULFILLMENT.REQUEST_STATUS;

export const mtposStockState = state => state.fulfillment?.mtposStock;
export const cartState = state => state.cart;

export const isSkuAvailable = createSelector(
  [mtposStockState, cartState],
  (mtposStock, cart) => {
    const deviceSku = cart?.order?.mobile?.device?.sku;
    const stockItem = mtposStock?.data?.find(ms => ms.itemCode === deviceSku);
    return stockItem?.availableQty > 0 || stockItem?.backorder === true;
  }
);
const initialState = {
  status: REQUEST_STATUS.IDLE,
  data: [],
  isLoading: false
};

const mtposStockReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case 'GET_MTPOS_LOADING': {
      return {
        ...state,
        status: REQUEST_STATUS.PENDING,
        hasError: false,
        errorCode: undefined,
        isLoading: true
      };
    }
    case 'GET_MTPOS_SUCCESS': {
      if (actions.meta?.append) {
        const merged = new Map(state.data.map(item => [item.itemCode, item]));
        (actions.payload || []).forEach(item => {
          merged.set(item.itemCode, item);
        });
        return {
          ...state,
          data: [...merged.values()],
          status: REQUEST_STATUS.SUCCEEDED,
          isLoading: false
        };
      }
      return {
        ...state,
        data: actions.payload,
        status: REQUEST_STATUS.SUCCEEDED,
        isLoading: false
      };
    }
    case 'RESET_RRP_FLOW': {
      return {
        ...state,
        data: [],
        status: REQUEST_STATUS.IDLE,
        isLoading: false
      };
    }
    case 'GET_MTPOS_ERROR': {
      return {
        ...state,
        status: REQUEST_STATUS.FAILED,
        hasError: true,
        errorCode: actions.payload,
        data: [],
        isLoading: false
      };
    }

    default: {
      return state;
    }
  }
};
export default mtposStockReducer;
